export const formatAddress = (address) => {
  if (!address) return "";
  let formattedAddress = [];
  if (address.city?.name) formattedAddress.push(address.city.name);
  if (address.state?.name) {
    formattedAddress.push(address.state.name);
  } else if (address.province?.name) {
    formattedAddress.push(address.province.name);
  }
  if (address.country?.name) formattedAddress.push(address.country.name);
  return formattedAddress.join(", ");
};

export const formatNestedAddress = (address) => {
  if (!address) return "";
  let formattedAddress = [];

  if (address.name) formattedAddress.push(address.name);
  if (address.province) formattedAddress.push(address.province.name);
  if (address.province?.country) formattedAddress.push(address.province.country.name);

  if (address.country) formattedAddress.push(address.country.name);
  return formattedAddress.join(", ");
};
